// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/admin/media_proof.proto (package guardianai.v1.admin, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/admin/media_proof.proto.
 */
export const file_guardianai_v1_admin_media_proof: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_empty]);

/**
 * @generated from message guardianai.v1.admin.MediaProofConfig
 */
export type MediaProofConfig = Message<"guardianai.v1.admin.MediaProofConfig"> & {
  /**
   * @generated from field: string page_state = 1;
   */
  pageState: string;

  /**
   * @generated from field: string ios_store_url = 2;
   */
  iosStoreUrl: string;

  /**
   * @generated from field: string android_store_url = 3;
   */
  androidStoreUrl: string;

  /**
   * @generated from field: string research_paper_url = 4;
   */
  researchPaperUrl: string;

  /**
   * @generated from field: string hero_image_url = 5;
   */
  heroImageUrl: string;

  /**
   * @generated from field: string og_image_url = 6;
   */
  ogImageUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.admin.MediaProofConfig
 */
export type MediaProofConfigJson = {
  /**
   * @generated from field: string page_state = 1;
   */
  pageState?: string;

  /**
   * @generated from field: string ios_store_url = 2;
   */
  iosStoreUrl?: string;

  /**
   * @generated from field: string android_store_url = 3;
   */
  androidStoreUrl?: string;

  /**
   * @generated from field: string research_paper_url = 4;
   */
  researchPaperUrl?: string;

  /**
   * @generated from field: string hero_image_url = 5;
   */
  heroImageUrl?: string;

  /**
   * @generated from field: string og_image_url = 6;
   */
  ogImageUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.admin.MediaProofConfig.
 * Use `create(MediaProofConfigSchema)` to create a new message.
 */
export const MediaProofConfigSchema: GenMessage<MediaProofConfig, {jsonType: MediaProofConfigJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_media_proof, 0);

/**
 * @generated from message guardianai.v1.admin.GetMediaProofConfigResponse
 */
export type GetMediaProofConfigResponse = Message<"guardianai.v1.admin.GetMediaProofConfigResponse"> & {
  /**
   * @generated from field: guardianai.v1.admin.MediaProofConfig config = 1;
   */
  config?: MediaProofConfig;
};

/**
 * @generated from message guardianai.v1.admin.GetMediaProofConfigResponse
 */
export type GetMediaProofConfigResponseJson = {
  /**
   * @generated from field: guardianai.v1.admin.MediaProofConfig config = 1;
   */
  config?: MediaProofConfigJson;
};

/**
 * Describes the message guardianai.v1.admin.GetMediaProofConfigResponse.
 * Use `create(GetMediaProofConfigResponseSchema)` to create a new message.
 */
export const GetMediaProofConfigResponseSchema: GenMessage<GetMediaProofConfigResponse, {jsonType: GetMediaProofConfigResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_media_proof, 1);

/**
 * @generated from message guardianai.v1.admin.UpdateMediaProofConfigRequest
 */
export type UpdateMediaProofConfigRequest = Message<"guardianai.v1.admin.UpdateMediaProofConfigRequest"> & {
  /**
   * @generated from field: string page_state = 1;
   */
  pageState: string;

  /**
   * @generated from field: string ios_store_url = 2;
   */
  iosStoreUrl: string;

  /**
   * @generated from field: string android_store_url = 3;
   */
  androidStoreUrl: string;

  /**
   * @generated from field: string research_paper_url = 4;
   */
  researchPaperUrl: string;

  /**
   * @generated from field: string hero_image_url = 5;
   */
  heroImageUrl: string;

  /**
   * @generated from field: string og_image_url = 6;
   */
  ogImageUrl: string;
};

/**
 * @generated from message guardianai.v1.admin.UpdateMediaProofConfigRequest
 */
export type UpdateMediaProofConfigRequestJson = {
  /**
   * @generated from field: string page_state = 1;
   */
  pageState?: string;

  /**
   * @generated from field: string ios_store_url = 2;
   */
  iosStoreUrl?: string;

  /**
   * @generated from field: string android_store_url = 3;
   */
  androidStoreUrl?: string;

  /**
   * @generated from field: string research_paper_url = 4;
   */
  researchPaperUrl?: string;

  /**
   * @generated from field: string hero_image_url = 5;
   */
  heroImageUrl?: string;

  /**
   * @generated from field: string og_image_url = 6;
   */
  ogImageUrl?: string;
};

/**
 * Describes the message guardianai.v1.admin.UpdateMediaProofConfigRequest.
 * Use `create(UpdateMediaProofConfigRequestSchema)` to create a new message.
 */
export const UpdateMediaProofConfigRequestSchema: GenMessage<UpdateMediaProofConfigRequest, {jsonType: UpdateMediaProofConfigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_media_proof, 2);

/**
 * @generated from message guardianai.v1.admin.SubscribeWaitlistRequest
 */
export type SubscribeWaitlistRequest = Message<"guardianai.v1.admin.SubscribeWaitlistRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string company = 3;
   */
  company: string;

  /**
   * @generated from field: string role = 4;
   */
  role: string;

  /**
   * @generated from field: string use_case = 5;
   */
  useCase: string;
};

/**
 * @generated from message guardianai.v1.admin.SubscribeWaitlistRequest
 */
export type SubscribeWaitlistRequestJson = {
  /**
   * @generated from field: string email = 1;
   */
  email?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string company = 3;
   */
  company?: string;

  /**
   * @generated from field: string role = 4;
   */
  role?: string;

  /**
   * @generated from field: string use_case = 5;
   */
  useCase?: string;
};

/**
 * Describes the message guardianai.v1.admin.SubscribeWaitlistRequest.
 * Use `create(SubscribeWaitlistRequestSchema)` to create a new message.
 */
export const SubscribeWaitlistRequestSchema: GenMessage<SubscribeWaitlistRequest, {jsonType: SubscribeWaitlistRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_media_proof, 3);

/**
 * @generated from message guardianai.v1.admin.SubscribeWaitlistResponse
 */
export type SubscribeWaitlistResponse = Message<"guardianai.v1.admin.SubscribeWaitlistResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.admin.SubscribeWaitlistResponse
 */
export type SubscribeWaitlistResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.admin.SubscribeWaitlistResponse.
 * Use `create(SubscribeWaitlistResponseSchema)` to create a new message.
 */
export const SubscribeWaitlistResponseSchema: GenMessage<SubscribeWaitlistResponse, {jsonType: SubscribeWaitlistResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_media_proof, 4);

/**
 * @generated from message guardianai.v1.admin.WaitlistSubmission
 */
export type WaitlistSubmission = Message<"guardianai.v1.admin.WaitlistSubmission"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string company = 4;
   */
  company: string;

  /**
   * @generated from field: string role = 5;
   */
  role: string;

  /**
   * @generated from field: string use_case = 6;
   */
  useCase: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.admin.WaitlistSubmission
 */
export type WaitlistSubmissionJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string email = 2;
   */
  email?: string;

  /**
   * @generated from field: string name = 3;
   */
  name?: string;

  /**
   * @generated from field: string company = 4;
   */
  company?: string;

  /**
   * @generated from field: string role = 5;
   */
  role?: string;

  /**
   * @generated from field: string use_case = 6;
   */
  useCase?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.admin.WaitlistSubmission.
 * Use `create(WaitlistSubmissionSchema)` to create a new message.
 */
export const WaitlistSubmissionSchema: GenMessage<WaitlistSubmission, {jsonType: WaitlistSubmissionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_media_proof, 5);

/**
 * @generated from message guardianai.v1.admin.GetWaitlistSubmissionsRequest
 */
export type GetWaitlistSubmissionsRequest = Message<"guardianai.v1.admin.GetWaitlistSubmissionsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.admin.GetWaitlistSubmissionsRequest
 */
export type GetWaitlistSubmissionsRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.admin.GetWaitlistSubmissionsRequest.
 * Use `create(GetWaitlistSubmissionsRequestSchema)` to create a new message.
 */
export const GetWaitlistSubmissionsRequestSchema: GenMessage<GetWaitlistSubmissionsRequest, {jsonType: GetWaitlistSubmissionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_media_proof, 6);

/**
 * @generated from message guardianai.v1.admin.GetWaitlistSubmissionsResponse
 */
export type GetWaitlistSubmissionsResponse = Message<"guardianai.v1.admin.GetWaitlistSubmissionsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.admin.WaitlistSubmission submissions = 1;
   */
  submissions: WaitlistSubmission[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.admin.GetWaitlistSubmissionsResponse
 */
export type GetWaitlistSubmissionsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.admin.WaitlistSubmission submissions = 1;
   */
  submissions?: WaitlistSubmissionJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.admin.GetWaitlistSubmissionsResponse.
 * Use `create(GetWaitlistSubmissionsResponseSchema)` to create a new message.
 */
export const GetWaitlistSubmissionsResponseSchema: GenMessage<GetWaitlistSubmissionsResponse, {jsonType: GetWaitlistSubmissionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_media_proof, 7);

/**
 * @generated from message guardianai.v1.admin.RagIntegrityConfig
 */
export type RagIntegrityConfig = Message<"guardianai.v1.admin.RagIntegrityConfig"> & {
  /**
   * waiting_list | product_page
   *
   * @generated from field: string page_state = 1;
   */
  pageState: string;

  /**
   * @generated from field: string saas_url = 2;
   */
  saasUrl: string;

  /**
   * @generated from field: string docker_image_url = 3;
   */
  dockerImageUrl: string;

  /**
   * @generated from field: string docs_url = 4;
   */
  docsUrl: string;

  /**
   * @generated from field: string hero_image_url = 5;
   */
  heroImageUrl: string;

  /**
   * @generated from field: string og_image_url = 6;
   */
  ogImageUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.admin.RagIntegrityConfig
 */
export type RagIntegrityConfigJson = {
  /**
   * waiting_list | product_page
   *
   * @generated from field: string page_state = 1;
   */
  pageState?: string;

  /**
   * @generated from field: string saas_url = 2;
   */
  saasUrl?: string;

  /**
   * @generated from field: string docker_image_url = 3;
   */
  dockerImageUrl?: string;

  /**
   * @generated from field: string docs_url = 4;
   */
  docsUrl?: string;

  /**
   * @generated from field: string hero_image_url = 5;
   */
  heroImageUrl?: string;

  /**
   * @generated from field: string og_image_url = 6;
   */
  ogImageUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.admin.RagIntegrityConfig.
 * Use `create(RagIntegrityConfigSchema)` to create a new message.
 */
export const RagIntegrityConfigSchema: GenMessage<RagIntegrityConfig, {jsonType: RagIntegrityConfigJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_media_proof, 8);

/**
 * @generated from message guardianai.v1.admin.GetRagIntegrityConfigResponse
 */
export type GetRagIntegrityConfigResponse = Message<"guardianai.v1.admin.GetRagIntegrityConfigResponse"> & {
  /**
   * @generated from field: guardianai.v1.admin.RagIntegrityConfig config = 1;
   */
  config?: RagIntegrityConfig;
};

/**
 * @generated from message guardianai.v1.admin.GetRagIntegrityConfigResponse
 */
export type GetRagIntegrityConfigResponseJson = {
  /**
   * @generated from field: guardianai.v1.admin.RagIntegrityConfig config = 1;
   */
  config?: RagIntegrityConfigJson;
};

/**
 * Describes the message guardianai.v1.admin.GetRagIntegrityConfigResponse.
 * Use `create(GetRagIntegrityConfigResponseSchema)` to create a new message.
 */
export const GetRagIntegrityConfigResponseSchema: GenMessage<GetRagIntegrityConfigResponse, {jsonType: GetRagIntegrityConfigResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_media_proof, 9);

/**
 * @generated from message guardianai.v1.admin.UpdateRagIntegrityConfigRequest
 */
export type UpdateRagIntegrityConfigRequest = Message<"guardianai.v1.admin.UpdateRagIntegrityConfigRequest"> & {
  /**
   * waiting_list | product_page
   *
   * @generated from field: string page_state = 1;
   */
  pageState: string;

  /**
   * @generated from field: string saas_url = 2;
   */
  saasUrl: string;

  /**
   * @generated from field: string docker_image_url = 3;
   */
  dockerImageUrl: string;

  /**
   * @generated from field: string docs_url = 4;
   */
  docsUrl: string;

  /**
   * @generated from field: string hero_image_url = 5;
   */
  heroImageUrl: string;

  /**
   * @generated from field: string og_image_url = 6;
   */
  ogImageUrl: string;
};

/**
 * @generated from message guardianai.v1.admin.UpdateRagIntegrityConfigRequest
 */
export type UpdateRagIntegrityConfigRequestJson = {
  /**
   * waiting_list | product_page
   *
   * @generated from field: string page_state = 1;
   */
  pageState?: string;

  /**
   * @generated from field: string saas_url = 2;
   */
  saasUrl?: string;

  /**
   * @generated from field: string docker_image_url = 3;
   */
  dockerImageUrl?: string;

  /**
   * @generated from field: string docs_url = 4;
   */
  docsUrl?: string;

  /**
   * @generated from field: string hero_image_url = 5;
   */
  heroImageUrl?: string;

  /**
   * @generated from field: string og_image_url = 6;
   */
  ogImageUrl?: string;
};

/**
 * Describes the message guardianai.v1.admin.UpdateRagIntegrityConfigRequest.
 * Use `create(UpdateRagIntegrityConfigRequestSchema)` to create a new message.
 */
export const UpdateRagIntegrityConfigRequestSchema: GenMessage<UpdateRagIntegrityConfigRequest, {jsonType: UpdateRagIntegrityConfigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_media_proof, 10);

/**
 * @generated from message guardianai.v1.admin.SubscribeRagIntegrityWaitlistRequest
 */
export type SubscribeRagIntegrityWaitlistRequest = Message<"guardianai.v1.admin.SubscribeRagIntegrityWaitlistRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string company = 3;
   */
  company: string;

  /**
   * @generated from field: string role = 4;
   */
  role: string;

  /**
   * @generated from field: string use_case = 5;
   */
  useCase: string;
};

/**
 * @generated from message guardianai.v1.admin.SubscribeRagIntegrityWaitlistRequest
 */
export type SubscribeRagIntegrityWaitlistRequestJson = {
  /**
   * @generated from field: string email = 1;
   */
  email?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string company = 3;
   */
  company?: string;

  /**
   * @generated from field: string role = 4;
   */
  role?: string;

  /**
   * @generated from field: string use_case = 5;
   */
  useCase?: string;
};

/**
 * Describes the message guardianai.v1.admin.SubscribeRagIntegrityWaitlistRequest.
 * Use `create(SubscribeRagIntegrityWaitlistRequestSchema)` to create a new message.
 */
export const SubscribeRagIntegrityWaitlistRequestSchema: GenMessage<SubscribeRagIntegrityWaitlistRequest, {jsonType: SubscribeRagIntegrityWaitlistRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_media_proof, 11);

/**
 * @generated from message guardianai.v1.admin.RagIntegrityWaitlistSubmission
 */
export type RagIntegrityWaitlistSubmission = Message<"guardianai.v1.admin.RagIntegrityWaitlistSubmission"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string company = 4;
   */
  company: string;

  /**
   * @generated from field: string role = 5;
   */
  role: string;

  /**
   * @generated from field: string use_case = 6;
   */
  useCase: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.admin.RagIntegrityWaitlistSubmission
 */
export type RagIntegrityWaitlistSubmissionJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string email = 2;
   */
  email?: string;

  /**
   * @generated from field: string name = 3;
   */
  name?: string;

  /**
   * @generated from field: string company = 4;
   */
  company?: string;

  /**
   * @generated from field: string role = 5;
   */
  role?: string;

  /**
   * @generated from field: string use_case = 6;
   */
  useCase?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.admin.RagIntegrityWaitlistSubmission.
 * Use `create(RagIntegrityWaitlistSubmissionSchema)` to create a new message.
 */
export const RagIntegrityWaitlistSubmissionSchema: GenMessage<RagIntegrityWaitlistSubmission, {jsonType: RagIntegrityWaitlistSubmissionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_media_proof, 12);

/**
 * @generated from message guardianai.v1.admin.GetRagIntegrityWaitlistSubmissionsResponse
 */
export type GetRagIntegrityWaitlistSubmissionsResponse = Message<"guardianai.v1.admin.GetRagIntegrityWaitlistSubmissionsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.admin.RagIntegrityWaitlistSubmission submissions = 1;
   */
  submissions: RagIntegrityWaitlistSubmission[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.admin.GetRagIntegrityWaitlistSubmissionsResponse
 */
export type GetRagIntegrityWaitlistSubmissionsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.admin.RagIntegrityWaitlistSubmission submissions = 1;
   */
  submissions?: RagIntegrityWaitlistSubmissionJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.admin.GetRagIntegrityWaitlistSubmissionsResponse.
 * Use `create(GetRagIntegrityWaitlistSubmissionsResponseSchema)` to create a new message.
 */
export const GetRagIntegrityWaitlistSubmissionsResponseSchema: GenMessage<GetRagIntegrityWaitlistSubmissionsResponse, {jsonType: GetRagIntegrityWaitlistSubmissionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_media_proof, 13);

/**
 * @generated from service guardianai.v1.admin.MediaProofService
 */
export const MediaProofService: GenService<{
  /**
   * @generated from rpc guardianai.v1.admin.MediaProofService.GetMediaProofConfig
   */
  getMediaProofConfig: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetMediaProofConfigResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.MediaProofService.UpdateMediaProofConfig
   */
  updateMediaProofConfig: {
    methodKind: "unary";
    input: typeof UpdateMediaProofConfigRequestSchema;
    output: typeof GetMediaProofConfigResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.MediaProofService.SubscribeWaitlist
   */
  subscribeWaitlist: {
    methodKind: "unary";
    input: typeof SubscribeWaitlistRequestSchema;
    output: typeof SubscribeWaitlistResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.MediaProofService.GetWaitlistSubmissions
   */
  getWaitlistSubmissions: {
    methodKind: "unary";
    input: typeof GetWaitlistSubmissionsRequestSchema;
    output: typeof GetWaitlistSubmissionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_admin_media_proof, 0);

/**
 * @generated from service guardianai.v1.admin.RagIntegritySentinelService
 */
export const RagIntegritySentinelService: GenService<{
  /**
   * @generated from rpc guardianai.v1.admin.RagIntegritySentinelService.GetRagIntegrityConfig
   */
  getRagIntegrityConfig: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetRagIntegrityConfigResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.RagIntegritySentinelService.UpdateRagIntegrityConfig
   */
  updateRagIntegrityConfig: {
    methodKind: "unary";
    input: typeof UpdateRagIntegrityConfigRequestSchema;
    output: typeof GetRagIntegrityConfigResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.RagIntegritySentinelService.SubscribeWaitlist
   */
  subscribeWaitlist: {
    methodKind: "unary";
    input: typeof SubscribeRagIntegrityWaitlistRequestSchema;
    output: typeof SubscribeWaitlistResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.RagIntegritySentinelService.GetWaitlistSubmissions
   */
  getWaitlistSubmissions: {
    methodKind: "unary";
    input: typeof GetWaitlistSubmissionsRequestSchema;
    output: typeof GetRagIntegrityWaitlistSubmissionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_admin_media_proof, 1);

